// user-profile-tab-content.ts
import { LitElement, html, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Account } from "./components/account-info";
import { PersonalInfo } from "./components/personal-info";
import { LocationInfo } from "./components/location-info";
import { URLsInfo } from "./components/urls-info";

import "./components";
import "./components/account-info";
import {
  USER_ACCOUNT_SETTINGS_WIDGETS_LAYOUT,
  USER_ACCOUNT_SETTINGS_MODE,
  USER_ACCOUNT_SETTINGS_ORIENTATION,
  USER_ACCOUNT_SETTINGS_SIDEBAR_DISPLAY_TYPE,
  IProfileContentCustomizations,
} from "@/types";

@customElement("sb-profile")
export class Profile extends LitElement {
  @property({ type: Object }) account!: Account;
  @property({ type: Object }) personal!: PersonalInfo;
  @property({ type: Object }) location!: LocationInfo;
  @property({ type: Object }) urls!: URLsInfo;
  @property({ type: Boolean }) showAvatarMenu: boolean = false;
  @property({ type: Object })
  @property({ attribute: false })
  modalIcon?: TemplateResult;

  @property({ type: String }) orientation: USER_ACCOUNT_SETTINGS_ORIENTATION =
    USER_ACCOUNT_SETTINGS_ORIENTATION.HORIZONTAL;
  @property({ type: String })
  sidebarDisplayType: USER_ACCOUNT_SETTINGS_SIDEBAR_DISPLAY_TYPE =
    USER_ACCOUNT_SETTINGS_SIDEBAR_DISPLAY_TYPE.REGULAR;
  @property({ type: String }) mode: USER_ACCOUNT_SETTINGS_MODE =
    USER_ACCOUNT_SETTINGS_MODE?.PAGE;

  @property({ type: String })
  widgetsLayout: USER_ACCOUNT_SETTINGS_WIDGETS_LAYOUT =
    USER_ACCOUNT_SETTINGS_WIDGETS_LAYOUT.ROW;

  @property({ type: Function }) toggleAvatarMenu!: (e: Event) => void;
  @property({ type: Function }) onAvatarChange!: () => void;
  @property({ type: Function }) onAvatarRemove!: () => void;
  @property({ type: Object }) content: IProfileContentCustomizations | null =
    null;
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="sb-account-settings-section-stack">
        <sb-account-info
          .content=${this.content?.account!}
          .account=${this.account}
          .layout=${this.widgetsLayout}
          .showAvatarMenu=${this.showAvatarMenu}
          .toggleAvatarMenu=${this.toggleAvatarMenu}
        ></sb-account-info>

        <sb-personal-info
          .content=${this.content?.personalInfo!}
          .personal=${this.personal}
          .layout=${this.widgetsLayout}
        ></sb-personal-info>
        <sb-location-info
          .content=${this.content?.locations!}
          .locationInfo=${this.location}
          .layout=${this.widgetsLayout}
        ></sb-location-info>
        <sb-urls-info
          .content=${this.content?.urls!}
          .URLsInfo=${this.urls}
          .layout=${this.widgetsLayout}
        ></sb-urls-info>
      </div>
    `;
  }
}
